// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoData_atom_orbit__LQErZ {
  width: 100%;
  height: 100%;
  position: absolute;
  animation: NoData_spin-right__tYg\\+5 5s linear infinite;
}
.NoData_dot__efjQr {
  background-color: #e7e0f1;
  border-radius: 50%;
  display: inline-block;
}
@keyframes NoData_spin-right__tYg\\+5 {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.NoData_no_record_div__\\+HsAD {
  border: #e7e0f1 solid 1px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #383838;
  padding: 40px 0px 40px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.NoData_textWrap__YsfPC {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
}
.NoData_title__OhlLL {
  font-weight: 700;
  font-size: 16px;
  line-height: 20.34px;
  color: #383838;
  margin-bottom: 10px;
}
.NoData_subTitle__dSjex {
  font-weight: 400;
  font-size: 14px;
  line-height: 18.34px;
  color: #383838;
}
`, "",{"version":3,"sources":["webpack://./src/styles/NoData.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAKlB,uDAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,iCAAiC;EACnC;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":[".atom_orbit {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  -webkit-animation: spin-right 5s linear infinite;\n  -moz-animation: spin-right 5s linear infinite;\n  -ms-animation: spin-right 5s linear infinite;\n  -o-animation: spin-right 5s linear infinite;\n  animation: spin-right 5s linear infinite;\n}\n.dot {\n  background-color: #e7e0f1;\n  border-radius: 50%;\n  display: inline-block;\n}\n@keyframes spin-right {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n.no_record_div {\n  border: #e7e0f1 solid 1px;\n  border-radius: 20px;\n  font-size: 16px;\n  line-height: 22px;\n  text-align: center;\n  color: #383838;\n  padding: 40px 0px 40px 0px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n.textWrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 200px;\n}\n.title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20.34px;\n  color: #383838;\n  margin-bottom: 10px;\n}\n.subTitle {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18.34px;\n  color: #383838;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"atom_orbit": `NoData_atom_orbit__LQErZ`,
	"spin-right": `NoData_spin-right__tYg+5`,
	"dot": `NoData_dot__efjQr`,
	"no_record_div": `NoData_no_record_div__+HsAD`,
	"textWrap": `NoData_textWrap__YsfPC`,
	"title": `NoData_title__OhlLL`,
	"subTitle": `NoData_subTitle__dSjex`
};
export default ___CSS_LOADER_EXPORT___;
